import { render, staticRenderFns } from "./delivery-goods.vue?vue&type=template&id=dc4070c4&scoped=true&"
import script from "./delivery-goods.vue?vue&type=script&lang=js&"
export * from "./delivery-goods.vue?vue&type=script&lang=js&"
import style0 from "./delivery-goods.vue?vue&type=style&index=0&id=dc4070c4&scoped=true&lang=css&"
import style1 from "./delivery-goods.vue?vue&type=style&index=1&id=dc4070c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4070c4",
  null
  
)

export default component.exports